__turbopack_context__.v({
  "analyzingBadge": "ClientAvatar-module__XpvDXq__analyzingBadge",
  "analyzingText": "ClientAvatar-module__XpvDXq__analyzingText",
  "container": "ClientAvatar-module__XpvDXq__container",
  "emptyActions": "ClientAvatar-module__XpvDXq__emptyActions",
  "loaderContainer": "ClientAvatar-module__XpvDXq__loaderContainer",
  "noOfferBox": "ClientAvatar-module__XpvDXq__noOfferBox",
  "notGeneratedMessage": "ClientAvatar-module__XpvDXq__notGeneratedMessage",
  "offerSelector": "ClientAvatar-module__XpvDXq__offerSelector",
});
